import React from 'react';

import {
  opArtifactType,
  opArtifactTypeName,
  opCount,
  opProjectArtifacts,
  opProjectName,
  opProjectRuns,
  opRunJobtype,
  varNode,
} from '@wandb/cg';

import * as CGReact from '../../cgreact';
import * as TableState from './PanelTable/tableState';
import {PanelNumber} from './PanelNumber';
import * as KeyValTable from './KeyValTable';
import * as Panel2 from './panel';

const inputType = 'project' as const;
type PanelProjectOverviewProps = Panel2.PanelProps<typeof inputType>;

const PanelProjectOverview: React.FC<PanelProjectOverviewProps> = props => {
  const project = props.input;
  const projectName = opProjectName({project});
  const projectRuns = opProjectRuns({project});
  const projectRunsCount = opCount({
    arr: projectRuns,
  } as any);

  const projectArtifacts = opProjectArtifacts({project});
  const projectArtifactsCount = opCount({
    arr: projectArtifacts,
  } as any);

  // Build run job types table

  let runJobTypesTable = TableState.emptyTable();

  runJobTypesTable = TableState.appendEmptyColumn(runJobTypesTable);
  const jobTypeColId =
    runJobTypesTable.order[runJobTypesTable.order.length - 1];
  runJobTypesTable = TableState.updateColumnSelect(
    runJobTypesTable,
    jobTypeColId,
    opRunJobtype({run: varNode('run', 'row')})
  );

  runJobTypesTable = {...runJobTypesTable, groupBy: [jobTypeColId]};

  runJobTypesTable = TableState.appendEmptyColumn(runJobTypesTable);
  const runCountColId =
    runJobTypesTable.order[runJobTypesTable.order.length - 1];
  runJobTypesTable = TableState.updateColumnSelect(
    runJobTypesTable,
    runCountColId,
    opCount({
      arr: varNode({type: 'list', objectType: 'run'}, 'row') as any,
    })
  );

  // Build artifact types query

  let artifactTypesTable = TableState.emptyTable();

  artifactTypesTable = TableState.appendEmptyColumn(artifactTypesTable);
  const artifactTypeColId =
    artifactTypesTable.order[artifactTypesTable.order.length - 1];
  artifactTypesTable = TableState.updateColumnSelect(
    artifactTypesTable,
    artifactTypeColId,
    opArtifactTypeName({
      artifactType: opArtifactType({
        artifact: varNode('artifact', 'row'),
      }),
    })
  );

  artifactTypesTable = {...artifactTypesTable, groupBy: [artifactTypeColId]};

  artifactTypesTable = TableState.appendEmptyColumn(artifactTypesTable);
  const artifactCountColId =
    artifactTypesTable.order[artifactTypesTable.order.length - 1];
  artifactTypesTable = TableState.updateColumnSelect(
    artifactTypesTable,
    artifactCountColId,
    opCount({
      arr: varNode({type: 'list', objectType: 'artifact'}, 'row') as any,
    })
  );

  const projectNameQuery = CGReact.useNodeValue(projectName);
  const projectRunsQuery = CGReact.useNodeValue(projectRunsCount);
  const projectArtifactsQuery = CGReact.useNodeValue(projectArtifactsCount);
  if (
    projectNameQuery.loading ||
    projectRunsQuery.loading ||
    projectArtifactsQuery.loading
  ) {
    return <div>-</div>;
  }

  const inputVar = varNode(props.input.type, 'input');
  return (
    <KeyValTable.Table>
      <KeyValTable.Row>
        <KeyValTable.Key>
          <KeyValTable.InputUpdateLink
            onClick={() =>
              props.updateInput?.(opProjectRuns({project: inputVar}) as any)
            }>
            Runs
          </KeyValTable.InputUpdateLink>
        </KeyValTable.Key>
        <KeyValTable.Val>
          <PanelNumber
            input={projectRunsCount as any}
            context={props.context}
            updateContext={props.updateContext}
            // Get rid of updateConfig
            updateConfig={() => console.log('HELLO')}
          />
        </KeyValTable.Val>
      </KeyValTable.Row>
      <KeyValTable.Row>
        <KeyValTable.Key>
          <KeyValTable.InputUpdateLink
            onClick={() =>
              props.updateInput?.(
                opProjectArtifacts({project: inputVar}) as any
              )
            }>
            Artifacts
          </KeyValTable.InputUpdateLink>
        </KeyValTable.Key>
        <KeyValTable.Val>
          <PanelNumber
            input={projectArtifactsCount as any}
            context={props.context}
            updateContext={props.updateContext}
            // Get rid of updateConfig
            updateConfig={() => console.log('HELLO')}
          />
        </KeyValTable.Val>
      </KeyValTable.Row>
    </KeyValTable.Table>
  );
};

export const Spec: Panel2.PanelSpec = {
  id: 'project-overview',
  Component: PanelProjectOverview,
  inputType,
};
